import React, { useEffect, useState } from "react";
import { Pane, Dialog, Button } from "evergreen-ui";
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import "react-datepicker/dist/react-datepicker.css";
import Lottie from "lottie-react-web";
 
import { toast } from "react-toastify";
import Preloading from "../Preload/Preloading";

const cookies = new Cookies();

const DetailsV2 = (props) => {
  const [spin, setSpin] = useState(false);
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(null);

  const handleChange = (date) => {
    setStartDate(date);
  };

  const callcomm = () => {
    setSpin(true);
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: Host + `activities/task/${props?.id}`,
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        //   console.log('tok', response.data.data);
        var arr = [];
        for (let i = 0; i < response?.data?.data?.length; i++) {
          let obj = {
            value: response?.data?.data[i],
          };
          arr.push(obj);
        }
        setData(arr);
        setSpin(false);
      })
      .catch((err) => {
        toast.error("Network Error");
      });
  };
  useEffect(()=>{
    callcomm();
  },[props?.showActivities])

  return (
    <Dialog
      isShown={props?.showActivities}
      hasHeader={false}
      onCloseComplete={() => props?.setShowActivities(false)}
      hasFooter={false}
      topOffset={100}
    >
      {/* {spin?<Preloading/>:null} */}
      {data&&data?.map((item, i) => (
        <div
          key={i}
          style={{
            fontSize: 15,
            padding: 5,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 6,
              height: 6,
              backgroundColor: "#2e6b95",
              borderRadius: 300,
              marginRight: 5,
            }}
          />
          <div>{item?.value}</div>
        </div>
      ))}
    </Dialog>
  );
};
export default DetailsV2;
